"use strict";
// tslint:disable
/**
 * Client Dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynonymsApi = exports.SynonymsApiFactory = exports.SynonymsApiFp = exports.SynonymsApiAxiosParamCreator = exports.RelatedSearchesApi = exports.RelatedSearchesApiFactory = exports.RelatedSearchesApiFp = exports.RelatedSearchesApiAxiosParamCreator = exports.RefinementsApi = exports.RefinementsApiFactory = exports.RefinementsApiFp = exports.RefinementsApiAxiosParamCreator = exports.GroupsApi = exports.GroupsApiFactory = exports.GroupsApiFp = exports.GroupsApiAxiosParamCreator = exports.BlogApi = exports.BlogApiFactory = exports.BlogApiFp = exports.BlogApiAxiosParamCreator = exports.SnRuleTargetsConfigType = exports.RefinementResourceModelStatusEnum = exports.ItemGroup = void 0;
const tslib_1 = require("tslib");
const globalImportUrl = tslib_1.__importStar(require("url"));
const axios_1 = tslib_1.__importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
var ItemGroup;
(function (ItemGroup) {
    ItemGroup["Index"] = "index";
    ItemGroup["List"] = "list";
})(ItemGroup = exports.ItemGroup || (exports.ItemGroup = {}));
/**
    * @export
    * @enum {string}
    */
var RefinementResourceModelStatusEnum;
(function (RefinementResourceModelStatusEnum) {
    RefinementResourceModelStatusEnum["Pending"] = "pending";
    RefinementResourceModelStatusEnum["Hidden"] = "hidden";
})(RefinementResourceModelStatusEnum = exports.RefinementResourceModelStatusEnum || (exports.RefinementResourceModelStatusEnum = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SnRuleTargetsConfigType;
(function (SnRuleTargetsConfigType) {
    SnRuleTargetsConfigType["QueryRules"] = "query-rules";
    SnRuleTargetsConfigType["RelatedSearches"] = "related-searches";
    SnRuleTargetsConfigType["Banners"] = "banners";
})(SnRuleTargetsConfigType = exports.SnRuleTargetsConfigType || (exports.SnRuleTargetsConfigType = {}));
/**
 * BlogApi - axios parameter creator
 * @export
 */
exports.BlogApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosts: async (options = {}) => {
            const localVarPath = `/api/blog`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasks: async (groupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getTasks.');
            }
            const localVarPath = `/api/groups/{groupId}/tasks`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BlogApi - functional programming interface
 * @export
 */
exports.BlogApiFp = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPosts(options) {
            const localVarAxiosArgs = await exports.BlogApiAxiosParamCreator(configuration).getPosts(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTasks(groupId, options) {
            const localVarAxiosArgs = await exports.BlogApiAxiosParamCreator(configuration).getTasks(groupId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * BlogApi - factory interface
 * @export
 */
exports.BlogApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPosts(options) {
            return exports.BlogApiFp(configuration).getPosts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTasks(groupId, options) {
            return exports.BlogApiFp(configuration).getTasks(groupId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BlogApi - object-oriented interface
 * @export
 * @class BlogApi
 * @extends {BaseAPI}
 */
class BlogApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlogApi
     */
    getPosts(options) {
        return exports.BlogApiFp(this.configuration).getPosts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlogApi
     */
    getTasks(groupId, options) {
        return exports.BlogApiFp(this.configuration).getTasks(groupId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BlogApi = BlogApi;
/**
 * GroupsApi - axios parameter creator
 * @export
 */
exports.GroupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {GroupResourceModel} groupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup: async (groupResourceModel, options = {}) => {
            // verify required parameter 'groupResourceModel' is not null or undefined
            if (groupResourceModel === null || groupResourceModel === undefined) {
                throw new base_1.RequiredError('groupResourceModel', 'Required parameter groupResourceModel was null or undefined when calling createGroup.');
            }
            const localVarPath = `/api/groups`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof groupResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(groupResourceModel !== undefined ? groupResourceModel : {}) : (groupResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup: async (groupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteGroup.');
            }
            const localVarPath = `/api/groups/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup: async (groupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getGroup.');
            }
            const localVarPath = `/api/groups/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [internalName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: async (internalName, options = {}) => {
            const localVarPath = `/api/groups`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (internalName !== undefined) {
                localVarQueryParameter['internalName'] = internalName;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGroups: async (options = {}) => {
            const localVarPath = `/api/groups-sync`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {GroupResourceModel} groupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup: async (groupId, groupResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateGroup.');
            }
            // verify required parameter 'groupResourceModel' is not null or undefined
            if (groupResourceModel === null || groupResourceModel === undefined) {
                throw new base_1.RequiredError('groupResourceModel', 'Required parameter groupResourceModel was null or undefined when calling updateGroup.');
            }
            const localVarPath = `/api/groups/{groupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof groupResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(groupResourceModel !== undefined ? groupResourceModel : {}) : (groupResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupName: async (groupId, body, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateGroupName.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new base_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateGroupName.');
            }
            const localVarPath = `/api/groups/{groupId}/name`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * GroupsApi - functional programming interface
 * @export
 */
exports.GroupsApiFp = function (configuration) {
    return {
        /**
         *
         * @param {GroupResourceModel} groupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroup(groupResourceModel, options) {
            const localVarAxiosArgs = await exports.GroupsApiAxiosParamCreator(configuration).createGroup(groupResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroup(groupId, options) {
            const localVarAxiosArgs = await exports.GroupsApiAxiosParamCreator(configuration).deleteGroup(groupId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroup(groupId, options) {
            const localVarAxiosArgs = await exports.GroupsApiAxiosParamCreator(configuration).getGroup(groupId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} [internalName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroups(internalName, options) {
            const localVarAxiosArgs = await exports.GroupsApiAxiosParamCreator(configuration).getGroups(internalName, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncGroups(options) {
            const localVarAxiosArgs = await exports.GroupsApiAxiosParamCreator(configuration).syncGroups(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {GroupResourceModel} groupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroup(groupId, groupResourceModel, options) {
            const localVarAxiosArgs = await exports.GroupsApiAxiosParamCreator(configuration).updateGroup(groupId, groupResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroupName(groupId, body, options) {
            const localVarAxiosArgs = await exports.GroupsApiAxiosParamCreator(configuration).updateGroupName(groupId, body, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * GroupsApi - factory interface
 * @export
 */
exports.GroupsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {GroupResourceModel} groupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(groupResourceModel, options) {
            return exports.GroupsApiFp(configuration).createGroup(groupResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroup(groupId, options) {
            return exports.GroupsApiFp(configuration).deleteGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(groupId, options) {
            return exports.GroupsApiFp(configuration).getGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [internalName]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(internalName, options) {
            return exports.GroupsApiFp(configuration).getGroups(internalName, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncGroups(options) {
            return exports.GroupsApiFp(configuration).syncGroups(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {GroupResourceModel} groupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroup(groupId, groupResourceModel, options) {
            return exports.GroupsApiFp(configuration).updateGroup(groupId, groupResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupName(groupId, body, options) {
            return exports.GroupsApiFp(configuration).updateGroupName(groupId, body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * GroupsApi - object-oriented interface
 * @export
 * @class GroupsApi
 * @extends {BaseAPI}
 */
class GroupsApi extends base_1.BaseAPI {
    /**
     *
     * @param {GroupResourceModel} groupResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    createGroup(groupResourceModel, options) {
        return exports.GroupsApiFp(this.configuration).createGroup(groupResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    deleteGroup(groupId, options) {
        return exports.GroupsApiFp(this.configuration).deleteGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    getGroup(groupId, options) {
        return exports.GroupsApiFp(this.configuration).getGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [internalName]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    getGroups(internalName, options) {
        return exports.GroupsApiFp(this.configuration).getGroups(internalName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    syncGroups(options) {
        return exports.GroupsApiFp(this.configuration).syncGroups(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {GroupResourceModel} groupResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    updateGroup(groupId, groupResourceModel, options) {
        return exports.GroupsApiFp(this.configuration).updateGroup(groupId, groupResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    updateGroupName(groupId, body, options) {
        return exports.GroupsApiFp(this.configuration).updateGroupName(groupId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.GroupsApi = GroupsApi;
/**
 * RefinementsApi - axios parameter creator
 * @export
 */
exports.RefinementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {RefinementResourceModel} refinementResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefinement: async (groupId, refinementsGroupId, refinementResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createRefinement.');
            }
            // verify required parameter 'refinementsGroupId' is not null or undefined
            if (refinementsGroupId === null || refinementsGroupId === undefined) {
                throw new base_1.RequiredError('refinementsGroupId', 'Required parameter refinementsGroupId was null or undefined when calling createRefinement.');
            }
            // verify required parameter 'refinementResourceModel' is not null or undefined
            if (refinementResourceModel === null || refinementResourceModel === undefined) {
                throw new base_1.RequiredError('refinementResourceModel', 'Required parameter refinementResourceModel was null or undefined when calling createRefinement.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements/{refinementsGroupId}/items`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"refinementsGroupId"}}`, encodeURIComponent(String(refinementsGroupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof refinementResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(refinementResourceModel !== undefined ? refinementResourceModel : {}) : (refinementResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {RefinementsGroupResourceModel} refinementsGroupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefinementsGroup: async (groupId, refinementsGroupResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createRefinementsGroup.');
            }
            // verify required parameter 'refinementsGroupResourceModel' is not null or undefined
            if (refinementsGroupResourceModel === null || refinementsGroupResourceModel === undefined) {
                throw new base_1.RequiredError('refinementsGroupResourceModel', 'Required parameter refinementsGroupResourceModel was null or undefined when calling createRefinementsGroup.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof refinementsGroupResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(refinementsGroupResourceModel !== undefined ? refinementsGroupResourceModel : {}) : (refinementsGroupResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRefinement: async (groupId, refinementsGroupId, refinementId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteRefinement.');
            }
            // verify required parameter 'refinementsGroupId' is not null or undefined
            if (refinementsGroupId === null || refinementsGroupId === undefined) {
                throw new base_1.RequiredError('refinementsGroupId', 'Required parameter refinementsGroupId was null or undefined when calling deleteRefinement.');
            }
            // verify required parameter 'refinementId' is not null or undefined
            if (refinementId === null || refinementId === undefined) {
                throw new base_1.RequiredError('refinementId', 'Required parameter refinementId was null or undefined when calling deleteRefinement.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements/{refinementsGroupId}/items/{refinementId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"refinementsGroupId"}}`, encodeURIComponent(String(refinementsGroupId)))
                .replace(`{${"refinementId"}}`, encodeURIComponent(String(refinementId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRefinementsGroup: async (groupId, refinementsGroupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteRefinementsGroup.');
            }
            // verify required parameter 'refinementsGroupId' is not null or undefined
            if (refinementsGroupId === null || refinementsGroupId === undefined) {
                throw new base_1.RequiredError('refinementsGroupId', 'Required parameter refinementsGroupId was null or undefined when calling deleteRefinementsGroup.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements/{refinementsGroupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"refinementsGroupId"}}`, encodeURIComponent(String(refinementsGroupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefinement: async (groupId, refinementsGroupId, refinementId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRefinement.');
            }
            // verify required parameter 'refinementsGroupId' is not null or undefined
            if (refinementsGroupId === null || refinementsGroupId === undefined) {
                throw new base_1.RequiredError('refinementsGroupId', 'Required parameter refinementsGroupId was null or undefined when calling getRefinement.');
            }
            // verify required parameter 'refinementId' is not null or undefined
            if (refinementId === null || refinementId === undefined) {
                throw new base_1.RequiredError('refinementId', 'Required parameter refinementId was null or undefined when calling getRefinement.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements/{refinementsGroupId}/items/{refinementId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"refinementsGroupId"}}`, encodeURIComponent(String(refinementsGroupId)))
                .replace(`{${"refinementId"}}`, encodeURIComponent(String(refinementId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} [fromQuery]
         * @param {string} [toQuery]
         * @param {'pending' | 'hidden'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefinements: async (groupId, refinementsGroupId, fromQuery, toQuery, status, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRefinements.');
            }
            // verify required parameter 'refinementsGroupId' is not null or undefined
            if (refinementsGroupId === null || refinementsGroupId === undefined) {
                throw new base_1.RequiredError('refinementsGroupId', 'Required parameter refinementsGroupId was null or undefined when calling getRefinements.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements/{refinementsGroupId}/items`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"refinementsGroupId"}}`, encodeURIComponent(String(refinementsGroupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (fromQuery !== undefined) {
                localVarQueryParameter['fromQuery'] = fromQuery;
            }
            if (toQuery !== undefined) {
                localVarQueryParameter['toQuery'] = toQuery;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefinementsGroup: async (groupId, refinementsGroupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRefinementsGroup.');
            }
            // verify required parameter 'refinementsGroupId' is not null or undefined
            if (refinementsGroupId === null || refinementsGroupId === undefined) {
                throw new base_1.RequiredError('refinementsGroupId', 'Required parameter refinementsGroupId was null or undefined when calling getRefinementsGroup.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements/{refinementsGroupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"refinementsGroupId"}}`, encodeURIComponent(String(refinementsGroupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefinementsGroups: async (groupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRefinementsGroups.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {RefinementResourceModel} refinementResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRefinement: async (groupId, refinementsGroupId, refinementId, refinementResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRefinement.');
            }
            // verify required parameter 'refinementsGroupId' is not null or undefined
            if (refinementsGroupId === null || refinementsGroupId === undefined) {
                throw new base_1.RequiredError('refinementsGroupId', 'Required parameter refinementsGroupId was null or undefined when calling updateRefinement.');
            }
            // verify required parameter 'refinementId' is not null or undefined
            if (refinementId === null || refinementId === undefined) {
                throw new base_1.RequiredError('refinementId', 'Required parameter refinementId was null or undefined when calling updateRefinement.');
            }
            // verify required parameter 'refinementResourceModel' is not null or undefined
            if (refinementResourceModel === null || refinementResourceModel === undefined) {
                throw new base_1.RequiredError('refinementResourceModel', 'Required parameter refinementResourceModel was null or undefined when calling updateRefinement.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements/{refinementsGroupId}/items/{refinementId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"refinementsGroupId"}}`, encodeURIComponent(String(refinementsGroupId)))
                .replace(`{${"refinementId"}}`, encodeURIComponent(String(refinementId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof refinementResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(refinementResourceModel !== undefined ? refinementResourceModel : {}) : (refinementResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRefinementStatus: async (groupId, refinementsGroupId, refinementId, body, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRefinementStatus.');
            }
            // verify required parameter 'refinementsGroupId' is not null or undefined
            if (refinementsGroupId === null || refinementsGroupId === undefined) {
                throw new base_1.RequiredError('refinementsGroupId', 'Required parameter refinementsGroupId was null or undefined when calling updateRefinementStatus.');
            }
            // verify required parameter 'refinementId' is not null or undefined
            if (refinementId === null || refinementId === undefined) {
                throw new base_1.RequiredError('refinementId', 'Required parameter refinementId was null or undefined when calling updateRefinementStatus.');
            }
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new base_1.RequiredError('body', 'Required parameter body was null or undefined when calling updateRefinementStatus.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements/{refinementsGroupId}/items/{refinementId}/status`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"refinementsGroupId"}}`, encodeURIComponent(String(refinementsGroupId)))
                .replace(`{${"refinementId"}}`, encodeURIComponent(String(refinementId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {RefinementsGroupResourceModel} refinementsGroupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRefinementsGroup: async (groupId, refinementsGroupId, refinementsGroupResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRefinementsGroup.');
            }
            // verify required parameter 'refinementsGroupId' is not null or undefined
            if (refinementsGroupId === null || refinementsGroupId === undefined) {
                throw new base_1.RequiredError('refinementsGroupId', 'Required parameter refinementsGroupId was null or undefined when calling updateRefinementsGroup.');
            }
            // verify required parameter 'refinementsGroupResourceModel' is not null or undefined
            if (refinementsGroupResourceModel === null || refinementsGroupResourceModel === undefined) {
                throw new base_1.RequiredError('refinementsGroupResourceModel', 'Required parameter refinementsGroupResourceModel was null or undefined when calling updateRefinementsGroup.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements/{refinementsGroupId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"refinementsGroupId"}}`, encodeURIComponent(String(refinementsGroupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof refinementsGroupResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(refinementsGroupResourceModel !== undefined ? refinementsGroupResourceModel : {}) : (refinementsGroupResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRefinementsGroupLastSyncEnd: async (groupId, refinementsGroupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRefinementsGroupLastSyncEnd.');
            }
            // verify required parameter 'refinementsGroupId' is not null or undefined
            if (refinementsGroupId === null || refinementsGroupId === undefined) {
                throw new base_1.RequiredError('refinementsGroupId', 'Required parameter refinementsGroupId was null or undefined when calling updateRefinementsGroupLastSyncEnd.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements/{refinementsGroupId}/lastsyncend`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"refinementsGroupId"}}`, encodeURIComponent(String(refinementsGroupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRefinementsGroupLastSyncStart: async (groupId, refinementsGroupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRefinementsGroupLastSyncStart.');
            }
            // verify required parameter 'refinementsGroupId' is not null or undefined
            if (refinementsGroupId === null || refinementsGroupId === undefined) {
                throw new base_1.RequiredError('refinementsGroupId', 'Required parameter refinementsGroupId was null or undefined when calling updateRefinementsGroupLastSyncStart.');
            }
            const localVarPath = `/api/groups/{groupId}/refinements/{refinementsGroupId}/lastsyncstart`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"refinementsGroupId"}}`, encodeURIComponent(String(refinementsGroupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RefinementsApi - functional programming interface
 * @export
 */
exports.RefinementsApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {RefinementResourceModel} refinementResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRefinement(groupId, refinementsGroupId, refinementResourceModel, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).createRefinement(groupId, refinementsGroupId, refinementResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {RefinementsGroupResourceModel} refinementsGroupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRefinementsGroup(groupId, refinementsGroupResourceModel, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).createRefinementsGroup(groupId, refinementsGroupResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRefinement(groupId, refinementsGroupId, refinementId, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).deleteRefinement(groupId, refinementsGroupId, refinementId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRefinementsGroup(groupId, refinementsGroupId, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).deleteRefinementsGroup(groupId, refinementsGroupId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRefinement(groupId, refinementsGroupId, refinementId, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).getRefinement(groupId, refinementsGroupId, refinementId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} [fromQuery]
         * @param {string} [toQuery]
         * @param {'pending' | 'hidden'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRefinements(groupId, refinementsGroupId, fromQuery, toQuery, status, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).getRefinements(groupId, refinementsGroupId, fromQuery, toQuery, status, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRefinementsGroup(groupId, refinementsGroupId, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).getRefinementsGroup(groupId, refinementsGroupId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRefinementsGroups(groupId, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).getRefinementsGroups(groupId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {RefinementResourceModel} refinementResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRefinement(groupId, refinementsGroupId, refinementId, refinementResourceModel, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).updateRefinement(groupId, refinementsGroupId, refinementId, refinementResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRefinementStatus(groupId, refinementsGroupId, refinementId, body, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).updateRefinementStatus(groupId, refinementsGroupId, refinementId, body, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {RefinementsGroupResourceModel} refinementsGroupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRefinementsGroup(groupId, refinementsGroupId, refinementsGroupResourceModel, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).updateRefinementsGroup(groupId, refinementsGroupId, refinementsGroupResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRefinementsGroupLastSyncEnd(groupId, refinementsGroupId, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).updateRefinementsGroupLastSyncEnd(groupId, refinementsGroupId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRefinementsGroupLastSyncStart(groupId, refinementsGroupId, options) {
            const localVarAxiosArgs = await exports.RefinementsApiAxiosParamCreator(configuration).updateRefinementsGroupLastSyncStart(groupId, refinementsGroupId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * RefinementsApi - factory interface
 * @export
 */
exports.RefinementsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {RefinementResourceModel} refinementResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefinement(groupId, refinementsGroupId, refinementResourceModel, options) {
            return exports.RefinementsApiFp(configuration).createRefinement(groupId, refinementsGroupId, refinementResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {RefinementsGroupResourceModel} refinementsGroupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRefinementsGroup(groupId, refinementsGroupResourceModel, options) {
            return exports.RefinementsApiFp(configuration).createRefinementsGroup(groupId, refinementsGroupResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRefinement(groupId, refinementsGroupId, refinementId, options) {
            return exports.RefinementsApiFp(configuration).deleteRefinement(groupId, refinementsGroupId, refinementId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRefinementsGroup(groupId, refinementsGroupId, options) {
            return exports.RefinementsApiFp(configuration).deleteRefinementsGroup(groupId, refinementsGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefinement(groupId, refinementsGroupId, refinementId, options) {
            return exports.RefinementsApiFp(configuration).getRefinement(groupId, refinementsGroupId, refinementId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} [fromQuery]
         * @param {string} [toQuery]
         * @param {'pending' | 'hidden'} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefinements(groupId, refinementsGroupId, fromQuery, toQuery, status, options) {
            return exports.RefinementsApiFp(configuration).getRefinements(groupId, refinementsGroupId, fromQuery, toQuery, status, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefinementsGroup(groupId, refinementsGroupId, options) {
            return exports.RefinementsApiFp(configuration).getRefinementsGroup(groupId, refinementsGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRefinementsGroups(groupId, options) {
            return exports.RefinementsApiFp(configuration).getRefinementsGroups(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {RefinementResourceModel} refinementResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRefinement(groupId, refinementsGroupId, refinementId, refinementResourceModel, options) {
            return exports.RefinementsApiFp(configuration).updateRefinement(groupId, refinementsGroupId, refinementId, refinementResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {string} refinementId
         * @param {string} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRefinementStatus(groupId, refinementsGroupId, refinementId, body, options) {
            return exports.RefinementsApiFp(configuration).updateRefinementStatus(groupId, refinementsGroupId, refinementId, body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {RefinementsGroupResourceModel} refinementsGroupResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRefinementsGroup(groupId, refinementsGroupId, refinementsGroupResourceModel, options) {
            return exports.RefinementsApiFp(configuration).updateRefinementsGroup(groupId, refinementsGroupId, refinementsGroupResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRefinementsGroupLastSyncEnd(groupId, refinementsGroupId, options) {
            return exports.RefinementsApiFp(configuration).updateRefinementsGroupLastSyncEnd(groupId, refinementsGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} refinementsGroupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRefinementsGroupLastSyncStart(groupId, refinementsGroupId, options) {
            return exports.RefinementsApiFp(configuration).updateRefinementsGroupLastSyncStart(groupId, refinementsGroupId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RefinementsApi - object-oriented interface
 * @export
 * @class RefinementsApi
 * @extends {BaseAPI}
 */
class RefinementsApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} groupId
     * @param {string} refinementsGroupId
     * @param {RefinementResourceModel} refinementResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    createRefinement(groupId, refinementsGroupId, refinementResourceModel, options) {
        return exports.RefinementsApiFp(this.configuration).createRefinement(groupId, refinementsGroupId, refinementResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {RefinementsGroupResourceModel} refinementsGroupResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    createRefinementsGroup(groupId, refinementsGroupResourceModel, options) {
        return exports.RefinementsApiFp(this.configuration).createRefinementsGroup(groupId, refinementsGroupResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} refinementsGroupId
     * @param {string} refinementId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    deleteRefinement(groupId, refinementsGroupId, refinementId, options) {
        return exports.RefinementsApiFp(this.configuration).deleteRefinement(groupId, refinementsGroupId, refinementId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} refinementsGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    deleteRefinementsGroup(groupId, refinementsGroupId, options) {
        return exports.RefinementsApiFp(this.configuration).deleteRefinementsGroup(groupId, refinementsGroupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} refinementsGroupId
     * @param {string} refinementId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    getRefinement(groupId, refinementsGroupId, refinementId, options) {
        return exports.RefinementsApiFp(this.configuration).getRefinement(groupId, refinementsGroupId, refinementId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} refinementsGroupId
     * @param {string} [fromQuery]
     * @param {string} [toQuery]
     * @param {'pending' | 'hidden'} [status]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    getRefinements(groupId, refinementsGroupId, fromQuery, toQuery, status, options) {
        return exports.RefinementsApiFp(this.configuration).getRefinements(groupId, refinementsGroupId, fromQuery, toQuery, status, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} refinementsGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    getRefinementsGroup(groupId, refinementsGroupId, options) {
        return exports.RefinementsApiFp(this.configuration).getRefinementsGroup(groupId, refinementsGroupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    getRefinementsGroups(groupId, options) {
        return exports.RefinementsApiFp(this.configuration).getRefinementsGroups(groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} refinementsGroupId
     * @param {string} refinementId
     * @param {RefinementResourceModel} refinementResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    updateRefinement(groupId, refinementsGroupId, refinementId, refinementResourceModel, options) {
        return exports.RefinementsApiFp(this.configuration).updateRefinement(groupId, refinementsGroupId, refinementId, refinementResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} refinementsGroupId
     * @param {string} refinementId
     * @param {string} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    updateRefinementStatus(groupId, refinementsGroupId, refinementId, body, options) {
        return exports.RefinementsApiFp(this.configuration).updateRefinementStatus(groupId, refinementsGroupId, refinementId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} refinementsGroupId
     * @param {RefinementsGroupResourceModel} refinementsGroupResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    updateRefinementsGroup(groupId, refinementsGroupId, refinementsGroupResourceModel, options) {
        return exports.RefinementsApiFp(this.configuration).updateRefinementsGroup(groupId, refinementsGroupId, refinementsGroupResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} refinementsGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    updateRefinementsGroupLastSyncEnd(groupId, refinementsGroupId, options) {
        return exports.RefinementsApiFp(this.configuration).updateRefinementsGroupLastSyncEnd(groupId, refinementsGroupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} refinementsGroupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RefinementsApi
     */
    updateRefinementsGroupLastSyncStart(groupId, refinementsGroupId, options) {
        return exports.RefinementsApiFp(this.configuration).updateRefinementsGroupLastSyncStart(groupId, refinementsGroupId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RefinementsApi = RefinementsApi;
/**
 * RelatedSearchesApi - axios parameter creator
 * @export
 */
exports.RelatedSearchesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {RelatedSearchesIndexResourceModel} relatedSearchesIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelatedSearchesIndex: async (groupId, relatedSearchesIndexResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createRelatedSearchesIndex.');
            }
            // verify required parameter 'relatedSearchesIndexResourceModel' is not null or undefined
            if (relatedSearchesIndexResourceModel === null || relatedSearchesIndexResourceModel === undefined) {
                throw new base_1.RequiredError('relatedSearchesIndexResourceModel', 'Required parameter relatedSearchesIndexResourceModel was null or undefined when calling createRelatedSearchesIndex.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof relatedSearchesIndexResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(relatedSearchesIndexResourceModel !== undefined ? relatedSearchesIndexResourceModel : {}) : (relatedSearchesIndexResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {RelatedSearchesIndexItemResourceModel} relatedSearchesIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelatedSearchesIndexItem: async (groupId, indexId, relatedSearchesIndexItemResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createRelatedSearchesIndexItem.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling createRelatedSearchesIndexItem.');
            }
            // verify required parameter 'relatedSearchesIndexItemResourceModel' is not null or undefined
            if (relatedSearchesIndexItemResourceModel === null || relatedSearchesIndexItemResourceModel === undefined) {
                throw new base_1.RequiredError('relatedSearchesIndexItemResourceModel', 'Required parameter relatedSearchesIndexItemResourceModel was null or undefined when calling createRelatedSearchesIndexItem.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes/{indexId}/items`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof relatedSearchesIndexItemResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(relatedSearchesIndexItemResourceModel !== undefined ? relatedSearchesIndexItemResourceModel : {}) : (relatedSearchesIndexItemResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {RelatedSearchesListResourceModel} relatedSearchesListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelatedSearchesList: async (groupId, relatedSearchesListResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createRelatedSearchesList.');
            }
            // verify required parameter 'relatedSearchesListResourceModel' is not null or undefined
            if (relatedSearchesListResourceModel === null || relatedSearchesListResourceModel === undefined) {
                throw new base_1.RequiredError('relatedSearchesListResourceModel', 'Required parameter relatedSearchesListResourceModel was null or undefined when calling createRelatedSearchesList.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/lists`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof relatedSearchesListResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(relatedSearchesListResourceModel !== undefined ? relatedSearchesListResourceModel : {}) : (relatedSearchesListResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {RelatedSearchesListItemResourceModel} relatedSearchesListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelatedSearchesListItem: async (groupId, listId, relatedSearchesListItemResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createRelatedSearchesListItem.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling createRelatedSearchesListItem.');
            }
            // verify required parameter 'relatedSearchesListItemResourceModel' is not null or undefined
            if (relatedSearchesListItemResourceModel === null || relatedSearchesListItemResourceModel === undefined) {
                throw new base_1.RequiredError('relatedSearchesListItemResourceModel', 'Required parameter relatedSearchesListItemResourceModel was null or undefined when calling createRelatedSearchesListItem.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/lists/{listId}/items`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof relatedSearchesListItemResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(relatedSearchesListItemResourceModel !== undefined ? relatedSearchesListItemResourceModel : {}) : (relatedSearchesListItemResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelatedSearchesIndex: async (groupId, indexId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteRelatedSearchesIndex.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling deleteRelatedSearchesIndex.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes/{indexId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelatedSearchesIndexItem: async (groupId, indexId, indexItemId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteRelatedSearchesIndexItem.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling deleteRelatedSearchesIndexItem.');
            }
            // verify required parameter 'indexItemId' is not null or undefined
            if (indexItemId === null || indexItemId === undefined) {
                throw new base_1.RequiredError('indexItemId', 'Required parameter indexItemId was null or undefined when calling deleteRelatedSearchesIndexItem.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes/{indexId}/items/{indexItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)))
                .replace(`{${"indexItemId"}}`, encodeURIComponent(String(indexItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelatedSearchesList: async (groupId, listId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteRelatedSearchesList.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling deleteRelatedSearchesList.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/lists/{listId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelatedSearchesListItem: async (groupId, listId, listItemId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteRelatedSearchesListItem.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling deleteRelatedSearchesListItem.');
            }
            // verify required parameter 'listItemId' is not null or undefined
            if (listItemId === null || listItemId === undefined) {
                throw new base_1.RequiredError('listItemId', 'Required parameter listItemId was null or undefined when calling deleteRelatedSearchesListItem.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/lists/{listId}/items/{listItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)))
                .replace(`{${"listItemId"}}`, encodeURIComponent(String(listItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesIndex: async (groupId, indexId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRelatedSearchesIndex.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling getRelatedSearchesIndex.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes/{indexId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesIndexItem: async (groupId, indexId, indexItemId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRelatedSearchesIndexItem.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling getRelatedSearchesIndexItem.');
            }
            // verify required parameter 'indexItemId' is not null or undefined
            if (indexItemId === null || indexItemId === undefined) {
                throw new base_1.RequiredError('indexItemId', 'Required parameter indexItemId was null or undefined when calling getRelatedSearchesIndexItem.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes/{indexId}/items/{indexItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)))
                .replace(`{${"indexItemId"}}`, encodeURIComponent(String(indexItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesIndexItems: async (groupId, indexId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRelatedSearchesIndexItems.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling getRelatedSearchesIndexItems.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes/{indexId}/items`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesIndexes: async (groupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRelatedSearchesIndexes.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesList: async (groupId, listId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRelatedSearchesList.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling getRelatedSearchesList.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/lists/{listId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesListItem: async (groupId, listId, listItemId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRelatedSearchesListItem.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling getRelatedSearchesListItem.');
            }
            // verify required parameter 'listItemId' is not null or undefined
            if (listItemId === null || listItemId === undefined) {
                throw new base_1.RequiredError('listItemId', 'Required parameter listItemId was null or undefined when calling getRelatedSearchesListItem.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/lists/{listId}/items/{listItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)))
                .replace(`{${"listItemId"}}`, encodeURIComponent(String(listItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesListItems: async (groupId, listId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRelatedSearchesListItems.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling getRelatedSearchesListItems.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/lists/{listId}/items`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {Array<string>} [indexIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesLists: async (groupId, indexIds, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getRelatedSearchesLists.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/lists`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (indexIds) {
                localVarQueryParameter['indexIds'] = indexIds;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {RelatedSearchesIndexResourceModel} relatedSearchesIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesIndex: async (groupId, indexId, relatedSearchesIndexResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRelatedSearchesIndex.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling updateRelatedSearchesIndex.');
            }
            // verify required parameter 'relatedSearchesIndexResourceModel' is not null or undefined
            if (relatedSearchesIndexResourceModel === null || relatedSearchesIndexResourceModel === undefined) {
                throw new base_1.RequiredError('relatedSearchesIndexResourceModel', 'Required parameter relatedSearchesIndexResourceModel was null or undefined when calling updateRelatedSearchesIndex.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes/{indexId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof relatedSearchesIndexResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(relatedSearchesIndexResourceModel !== undefined ? relatedSearchesIndexResourceModel : {}) : (relatedSearchesIndexResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {RelatedSearchesIndexItemResourceModel} relatedSearchesIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesIndexItem: async (groupId, indexId, indexItemId, relatedSearchesIndexItemResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRelatedSearchesIndexItem.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling updateRelatedSearchesIndexItem.');
            }
            // verify required parameter 'indexItemId' is not null or undefined
            if (indexItemId === null || indexItemId === undefined) {
                throw new base_1.RequiredError('indexItemId', 'Required parameter indexItemId was null or undefined when calling updateRelatedSearchesIndexItem.');
            }
            // verify required parameter 'relatedSearchesIndexItemResourceModel' is not null or undefined
            if (relatedSearchesIndexItemResourceModel === null || relatedSearchesIndexItemResourceModel === undefined) {
                throw new base_1.RequiredError('relatedSearchesIndexItemResourceModel', 'Required parameter relatedSearchesIndexItemResourceModel was null or undefined when calling updateRelatedSearchesIndexItem.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes/{indexId}/items/{indexItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)))
                .replace(`{${"indexItemId"}}`, encodeURIComponent(String(indexItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof relatedSearchesIndexItemResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(relatedSearchesIndexItemResourceModel !== undefined ? relatedSearchesIndexItemResourceModel : {}) : (relatedSearchesIndexItemResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesIndexLastSyncEnd: async (groupId, indexId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRelatedSearchesIndexLastSyncEnd.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling updateRelatedSearchesIndexLastSyncEnd.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes/{indexId}/lastsyncend`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesIndexLastSyncStart: async (groupId, indexId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRelatedSearchesIndexLastSyncStart.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling updateRelatedSearchesIndexLastSyncStart.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/indexes/{indexId}/lastsyncstart`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {RelatedSearchesListResourceModel} relatedSearchesListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesList: async (groupId, listId, relatedSearchesListResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRelatedSearchesList.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling updateRelatedSearchesList.');
            }
            // verify required parameter 'relatedSearchesListResourceModel' is not null or undefined
            if (relatedSearchesListResourceModel === null || relatedSearchesListResourceModel === undefined) {
                throw new base_1.RequiredError('relatedSearchesListResourceModel', 'Required parameter relatedSearchesListResourceModel was null or undefined when calling updateRelatedSearchesList.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/lists/{listId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof relatedSearchesListResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(relatedSearchesListResourceModel !== undefined ? relatedSearchesListResourceModel : {}) : (relatedSearchesListResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {RelatedSearchesListItemResourceModel} relatedSearchesListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesListItem: async (groupId, listId, listItemId, relatedSearchesListItemResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateRelatedSearchesListItem.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling updateRelatedSearchesListItem.');
            }
            // verify required parameter 'listItemId' is not null or undefined
            if (listItemId === null || listItemId === undefined) {
                throw new base_1.RequiredError('listItemId', 'Required parameter listItemId was null or undefined when calling updateRelatedSearchesListItem.');
            }
            // verify required parameter 'relatedSearchesListItemResourceModel' is not null or undefined
            if (relatedSearchesListItemResourceModel === null || relatedSearchesListItemResourceModel === undefined) {
                throw new base_1.RequiredError('relatedSearchesListItemResourceModel', 'Required parameter relatedSearchesListItemResourceModel was null or undefined when calling updateRelatedSearchesListItem.');
            }
            const localVarPath = `/api/groups/{groupId}/relatedsearches/lists/{listId}/items/{listItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)))
                .replace(`{${"listItemId"}}`, encodeURIComponent(String(listItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof relatedSearchesListItemResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(relatedSearchesListItemResourceModel !== undefined ? relatedSearchesListItemResourceModel : {}) : (relatedSearchesListItemResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RelatedSearchesApi - functional programming interface
 * @export
 */
exports.RelatedSearchesApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {RelatedSearchesIndexResourceModel} relatedSearchesIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRelatedSearchesIndex(groupId, relatedSearchesIndexResourceModel, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).createRelatedSearchesIndex(groupId, relatedSearchesIndexResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {RelatedSearchesIndexItemResourceModel} relatedSearchesIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRelatedSearchesIndexItem(groupId, indexId, relatedSearchesIndexItemResourceModel, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).createRelatedSearchesIndexItem(groupId, indexId, relatedSearchesIndexItemResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {RelatedSearchesListResourceModel} relatedSearchesListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRelatedSearchesList(groupId, relatedSearchesListResourceModel, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).createRelatedSearchesList(groupId, relatedSearchesListResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {RelatedSearchesListItemResourceModel} relatedSearchesListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRelatedSearchesListItem(groupId, listId, relatedSearchesListItemResourceModel, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).createRelatedSearchesListItem(groupId, listId, relatedSearchesListItemResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRelatedSearchesIndex(groupId, indexId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).deleteRelatedSearchesIndex(groupId, indexId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRelatedSearchesIndexItem(groupId, indexId, indexItemId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).deleteRelatedSearchesIndexItem(groupId, indexId, indexItemId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRelatedSearchesList(groupId, listId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).deleteRelatedSearchesList(groupId, listId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRelatedSearchesListItem(groupId, listId, listItemId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).deleteRelatedSearchesListItem(groupId, listId, listItemId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedSearchesIndex(groupId, indexId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).getRelatedSearchesIndex(groupId, indexId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedSearchesIndexItem(groupId, indexId, indexItemId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).getRelatedSearchesIndexItem(groupId, indexId, indexItemId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedSearchesIndexItems(groupId, indexId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).getRelatedSearchesIndexItems(groupId, indexId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedSearchesIndexes(groupId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).getRelatedSearchesIndexes(groupId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedSearchesList(groupId, listId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).getRelatedSearchesList(groupId, listId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedSearchesListItem(groupId, listId, listItemId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).getRelatedSearchesListItem(groupId, listId, listItemId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedSearchesListItems(groupId, listId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).getRelatedSearchesListItems(groupId, listId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {Array<string>} [indexIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedSearchesLists(groupId, indexIds, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).getRelatedSearchesLists(groupId, indexIds, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {RelatedSearchesIndexResourceModel} relatedSearchesIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelatedSearchesIndex(groupId, indexId, relatedSearchesIndexResourceModel, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).updateRelatedSearchesIndex(groupId, indexId, relatedSearchesIndexResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {RelatedSearchesIndexItemResourceModel} relatedSearchesIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelatedSearchesIndexItem(groupId, indexId, indexItemId, relatedSearchesIndexItemResourceModel, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).updateRelatedSearchesIndexItem(groupId, indexId, indexItemId, relatedSearchesIndexItemResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelatedSearchesIndexLastSyncEnd(groupId, indexId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).updateRelatedSearchesIndexLastSyncEnd(groupId, indexId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelatedSearchesIndexLastSyncStart(groupId, indexId, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).updateRelatedSearchesIndexLastSyncStart(groupId, indexId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {RelatedSearchesListResourceModel} relatedSearchesListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelatedSearchesList(groupId, listId, relatedSearchesListResourceModel, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).updateRelatedSearchesList(groupId, listId, relatedSearchesListResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {RelatedSearchesListItemResourceModel} relatedSearchesListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelatedSearchesListItem(groupId, listId, listItemId, relatedSearchesListItemResourceModel, options) {
            const localVarAxiosArgs = await exports.RelatedSearchesApiAxiosParamCreator(configuration).updateRelatedSearchesListItem(groupId, listId, listItemId, relatedSearchesListItemResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * RelatedSearchesApi - factory interface
 * @export
 */
exports.RelatedSearchesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {RelatedSearchesIndexResourceModel} relatedSearchesIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelatedSearchesIndex(groupId, relatedSearchesIndexResourceModel, options) {
            return exports.RelatedSearchesApiFp(configuration).createRelatedSearchesIndex(groupId, relatedSearchesIndexResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {RelatedSearchesIndexItemResourceModel} relatedSearchesIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelatedSearchesIndexItem(groupId, indexId, relatedSearchesIndexItemResourceModel, options) {
            return exports.RelatedSearchesApiFp(configuration).createRelatedSearchesIndexItem(groupId, indexId, relatedSearchesIndexItemResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {RelatedSearchesListResourceModel} relatedSearchesListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelatedSearchesList(groupId, relatedSearchesListResourceModel, options) {
            return exports.RelatedSearchesApiFp(configuration).createRelatedSearchesList(groupId, relatedSearchesListResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {RelatedSearchesListItemResourceModel} relatedSearchesListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelatedSearchesListItem(groupId, listId, relatedSearchesListItemResourceModel, options) {
            return exports.RelatedSearchesApiFp(configuration).createRelatedSearchesListItem(groupId, listId, relatedSearchesListItemResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelatedSearchesIndex(groupId, indexId, options) {
            return exports.RelatedSearchesApiFp(configuration).deleteRelatedSearchesIndex(groupId, indexId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelatedSearchesIndexItem(groupId, indexId, indexItemId, options) {
            return exports.RelatedSearchesApiFp(configuration).deleteRelatedSearchesIndexItem(groupId, indexId, indexItemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelatedSearchesList(groupId, listId, options) {
            return exports.RelatedSearchesApiFp(configuration).deleteRelatedSearchesList(groupId, listId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelatedSearchesListItem(groupId, listId, listItemId, options) {
            return exports.RelatedSearchesApiFp(configuration).deleteRelatedSearchesListItem(groupId, listId, listItemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesIndex(groupId, indexId, options) {
            return exports.RelatedSearchesApiFp(configuration).getRelatedSearchesIndex(groupId, indexId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesIndexItem(groupId, indexId, indexItemId, options) {
            return exports.RelatedSearchesApiFp(configuration).getRelatedSearchesIndexItem(groupId, indexId, indexItemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesIndexItems(groupId, indexId, options) {
            return exports.RelatedSearchesApiFp(configuration).getRelatedSearchesIndexItems(groupId, indexId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesIndexes(groupId, options) {
            return exports.RelatedSearchesApiFp(configuration).getRelatedSearchesIndexes(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesList(groupId, listId, options) {
            return exports.RelatedSearchesApiFp(configuration).getRelatedSearchesList(groupId, listId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesListItem(groupId, listId, listItemId, options) {
            return exports.RelatedSearchesApiFp(configuration).getRelatedSearchesListItem(groupId, listId, listItemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesListItems(groupId, listId, options) {
            return exports.RelatedSearchesApiFp(configuration).getRelatedSearchesListItems(groupId, listId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {Array<string>} [indexIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedSearchesLists(groupId, indexIds, options) {
            return exports.RelatedSearchesApiFp(configuration).getRelatedSearchesLists(groupId, indexIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {RelatedSearchesIndexResourceModel} relatedSearchesIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesIndex(groupId, indexId, relatedSearchesIndexResourceModel, options) {
            return exports.RelatedSearchesApiFp(configuration).updateRelatedSearchesIndex(groupId, indexId, relatedSearchesIndexResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {RelatedSearchesIndexItemResourceModel} relatedSearchesIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesIndexItem(groupId, indexId, indexItemId, relatedSearchesIndexItemResourceModel, options) {
            return exports.RelatedSearchesApiFp(configuration).updateRelatedSearchesIndexItem(groupId, indexId, indexItemId, relatedSearchesIndexItemResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesIndexLastSyncEnd(groupId, indexId, options) {
            return exports.RelatedSearchesApiFp(configuration).updateRelatedSearchesIndexLastSyncEnd(groupId, indexId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesIndexLastSyncStart(groupId, indexId, options) {
            return exports.RelatedSearchesApiFp(configuration).updateRelatedSearchesIndexLastSyncStart(groupId, indexId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {RelatedSearchesListResourceModel} relatedSearchesListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesList(groupId, listId, relatedSearchesListResourceModel, options) {
            return exports.RelatedSearchesApiFp(configuration).updateRelatedSearchesList(groupId, listId, relatedSearchesListResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {RelatedSearchesListItemResourceModel} relatedSearchesListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedSearchesListItem(groupId, listId, listItemId, relatedSearchesListItemResourceModel, options) {
            return exports.RelatedSearchesApiFp(configuration).updateRelatedSearchesListItem(groupId, listId, listItemId, relatedSearchesListItemResourceModel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RelatedSearchesApi - object-oriented interface
 * @export
 * @class RelatedSearchesApi
 * @extends {BaseAPI}
 */
class RelatedSearchesApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} groupId
     * @param {RelatedSearchesIndexResourceModel} relatedSearchesIndexResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    createRelatedSearchesIndex(groupId, relatedSearchesIndexResourceModel, options) {
        return exports.RelatedSearchesApiFp(this.configuration).createRelatedSearchesIndex(groupId, relatedSearchesIndexResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {RelatedSearchesIndexItemResourceModel} relatedSearchesIndexItemResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    createRelatedSearchesIndexItem(groupId, indexId, relatedSearchesIndexItemResourceModel, options) {
        return exports.RelatedSearchesApiFp(this.configuration).createRelatedSearchesIndexItem(groupId, indexId, relatedSearchesIndexItemResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {RelatedSearchesListResourceModel} relatedSearchesListResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    createRelatedSearchesList(groupId, relatedSearchesListResourceModel, options) {
        return exports.RelatedSearchesApiFp(this.configuration).createRelatedSearchesList(groupId, relatedSearchesListResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {RelatedSearchesListItemResourceModel} relatedSearchesListItemResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    createRelatedSearchesListItem(groupId, listId, relatedSearchesListItemResourceModel, options) {
        return exports.RelatedSearchesApiFp(this.configuration).createRelatedSearchesListItem(groupId, listId, relatedSearchesListItemResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    deleteRelatedSearchesIndex(groupId, indexId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).deleteRelatedSearchesIndex(groupId, indexId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {string} indexItemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    deleteRelatedSearchesIndexItem(groupId, indexId, indexItemId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).deleteRelatedSearchesIndexItem(groupId, indexId, indexItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    deleteRelatedSearchesList(groupId, listId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).deleteRelatedSearchesList(groupId, listId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {string} listItemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    deleteRelatedSearchesListItem(groupId, listId, listItemId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).deleteRelatedSearchesListItem(groupId, listId, listItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    getRelatedSearchesIndex(groupId, indexId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).getRelatedSearchesIndex(groupId, indexId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {string} indexItemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    getRelatedSearchesIndexItem(groupId, indexId, indexItemId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).getRelatedSearchesIndexItem(groupId, indexId, indexItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    getRelatedSearchesIndexItems(groupId, indexId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).getRelatedSearchesIndexItems(groupId, indexId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    getRelatedSearchesIndexes(groupId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).getRelatedSearchesIndexes(groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    getRelatedSearchesList(groupId, listId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).getRelatedSearchesList(groupId, listId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {string} listItemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    getRelatedSearchesListItem(groupId, listId, listItemId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).getRelatedSearchesListItem(groupId, listId, listItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    getRelatedSearchesListItems(groupId, listId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).getRelatedSearchesListItems(groupId, listId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {Array<string>} [indexIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    getRelatedSearchesLists(groupId, indexIds, options) {
        return exports.RelatedSearchesApiFp(this.configuration).getRelatedSearchesLists(groupId, indexIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {RelatedSearchesIndexResourceModel} relatedSearchesIndexResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    updateRelatedSearchesIndex(groupId, indexId, relatedSearchesIndexResourceModel, options) {
        return exports.RelatedSearchesApiFp(this.configuration).updateRelatedSearchesIndex(groupId, indexId, relatedSearchesIndexResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {string} indexItemId
     * @param {RelatedSearchesIndexItemResourceModel} relatedSearchesIndexItemResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    updateRelatedSearchesIndexItem(groupId, indexId, indexItemId, relatedSearchesIndexItemResourceModel, options) {
        return exports.RelatedSearchesApiFp(this.configuration).updateRelatedSearchesIndexItem(groupId, indexId, indexItemId, relatedSearchesIndexItemResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    updateRelatedSearchesIndexLastSyncEnd(groupId, indexId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).updateRelatedSearchesIndexLastSyncEnd(groupId, indexId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    updateRelatedSearchesIndexLastSyncStart(groupId, indexId, options) {
        return exports.RelatedSearchesApiFp(this.configuration).updateRelatedSearchesIndexLastSyncStart(groupId, indexId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {RelatedSearchesListResourceModel} relatedSearchesListResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    updateRelatedSearchesList(groupId, listId, relatedSearchesListResourceModel, options) {
        return exports.RelatedSearchesApiFp(this.configuration).updateRelatedSearchesList(groupId, listId, relatedSearchesListResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {string} listItemId
     * @param {RelatedSearchesListItemResourceModel} relatedSearchesListItemResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelatedSearchesApi
     */
    updateRelatedSearchesListItem(groupId, listId, listItemId, relatedSearchesListItemResourceModel, options) {
        return exports.RelatedSearchesApiFp(this.configuration).updateRelatedSearchesListItem(groupId, listId, listItemId, relatedSearchesListItemResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RelatedSearchesApi = RelatedSearchesApi;
/**
 * SynonymsApi - axios parameter creator
 * @export
 */
exports.SynonymsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {SynonymsIndexResourceModel} synonymsIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSynonymsIndex: async (groupId, synonymsIndexResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createSynonymsIndex.');
            }
            // verify required parameter 'synonymsIndexResourceModel' is not null or undefined
            if (synonymsIndexResourceModel === null || synonymsIndexResourceModel === undefined) {
                throw new base_1.RequiredError('synonymsIndexResourceModel', 'Required parameter synonymsIndexResourceModel was null or undefined when calling createSynonymsIndex.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof synonymsIndexResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(synonymsIndexResourceModel !== undefined ? synonymsIndexResourceModel : {}) : (synonymsIndexResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {SynonymsIndexItemResourceModel} synonymsIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSynonymsIndexItem: async (groupId, indexId, synonymsIndexItemResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createSynonymsIndexItem.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling createSynonymsIndexItem.');
            }
            // verify required parameter 'synonymsIndexItemResourceModel' is not null or undefined
            if (synonymsIndexItemResourceModel === null || synonymsIndexItemResourceModel === undefined) {
                throw new base_1.RequiredError('synonymsIndexItemResourceModel', 'Required parameter synonymsIndexItemResourceModel was null or undefined when calling createSynonymsIndexItem.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes/{indexId}/items`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof synonymsIndexItemResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(synonymsIndexItemResourceModel !== undefined ? synonymsIndexItemResourceModel : {}) : (synonymsIndexItemResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {SynonymsListResourceModel} synonymsListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSynonymsList: async (groupId, synonymsListResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createSynonymsList.');
            }
            // verify required parameter 'synonymsListResourceModel' is not null or undefined
            if (synonymsListResourceModel === null || synonymsListResourceModel === undefined) {
                throw new base_1.RequiredError('synonymsListResourceModel', 'Required parameter synonymsListResourceModel was null or undefined when calling createSynonymsList.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/lists`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof synonymsListResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(synonymsListResourceModel !== undefined ? synonymsListResourceModel : {}) : (synonymsListResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {SynonymsListItemResourceModel} synonymsListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSynonymsListItem: async (groupId, listId, synonymsListItemResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling createSynonymsListItem.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling createSynonymsListItem.');
            }
            // verify required parameter 'synonymsListItemResourceModel' is not null or undefined
            if (synonymsListItemResourceModel === null || synonymsListItemResourceModel === undefined) {
                throw new base_1.RequiredError('synonymsListItemResourceModel', 'Required parameter synonymsListItemResourceModel was null or undefined when calling createSynonymsListItem.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/lists/{listId}/items`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof synonymsListItemResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(synonymsListItemResourceModel !== undefined ? synonymsListItemResourceModel : {}) : (synonymsListItemResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSynonymsIndex: async (groupId, indexId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteSynonymsIndex.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling deleteSynonymsIndex.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes/{indexId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSynonymsIndexItem: async (groupId, indexId, indexItemId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteSynonymsIndexItem.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling deleteSynonymsIndexItem.');
            }
            // verify required parameter 'indexItemId' is not null or undefined
            if (indexItemId === null || indexItemId === undefined) {
                throw new base_1.RequiredError('indexItemId', 'Required parameter indexItemId was null or undefined when calling deleteSynonymsIndexItem.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes/{indexId}/items/{indexItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)))
                .replace(`{${"indexItemId"}}`, encodeURIComponent(String(indexItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSynonymsList: async (groupId, listId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteSynonymsList.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling deleteSynonymsList.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/lists/{listId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSynonymsListItem: async (groupId, listId, listItemId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling deleteSynonymsListItem.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling deleteSynonymsListItem.');
            }
            // verify required parameter 'listItemId' is not null or undefined
            if (listItemId === null || listItemId === undefined) {
                throw new base_1.RequiredError('listItemId', 'Required parameter listItemId was null or undefined when calling deleteSynonymsListItem.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/lists/{listId}/items/{listItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)))
                .replace(`{${"listItemId"}}`, encodeURIComponent(String(listItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsIndex: async (groupId, indexId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getSynonymsIndex.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling getSynonymsIndex.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes/{indexId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsIndexItem: async (groupId, indexId, indexItemId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getSynonymsIndexItem.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling getSynonymsIndexItem.');
            }
            // verify required parameter 'indexItemId' is not null or undefined
            if (indexItemId === null || indexItemId === undefined) {
                throw new base_1.RequiredError('indexItemId', 'Required parameter indexItemId was null or undefined when calling getSynonymsIndexItem.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes/{indexId}/items/{indexItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)))
                .replace(`{${"indexItemId"}}`, encodeURIComponent(String(indexItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsIndexItems: async (groupId, indexId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getSynonymsIndexItems.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling getSynonymsIndexItems.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes/{indexId}/items`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsIndexes: async (groupId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getSynonymsIndexes.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsList: async (groupId, listId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getSynonymsList.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling getSynonymsList.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/lists/{listId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsListItem: async (groupId, listId, listItemId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getSynonymsListItem.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling getSynonymsListItem.');
            }
            // verify required parameter 'listItemId' is not null or undefined
            if (listItemId === null || listItemId === undefined) {
                throw new base_1.RequiredError('listItemId', 'Required parameter listItemId was null or undefined when calling getSynonymsListItem.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/lists/{listId}/items/{listItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)))
                .replace(`{${"listItemId"}}`, encodeURIComponent(String(listItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsListItems: async (groupId, listId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getSynonymsListItems.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling getSynonymsListItems.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/lists/{listId}/items`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {Array<string>} [indexIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsLists: async (groupId, indexIds, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling getSynonymsLists.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/lists`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (indexIds) {
                localVarQueryParameter['indexIds'] = indexIds;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {SynonymsIndexResourceModel} synonymsIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsIndex: async (groupId, indexId, synonymsIndexResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateSynonymsIndex.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling updateSynonymsIndex.');
            }
            // verify required parameter 'synonymsIndexResourceModel' is not null or undefined
            if (synonymsIndexResourceModel === null || synonymsIndexResourceModel === undefined) {
                throw new base_1.RequiredError('synonymsIndexResourceModel', 'Required parameter synonymsIndexResourceModel was null or undefined when calling updateSynonymsIndex.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes/{indexId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof synonymsIndexResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(synonymsIndexResourceModel !== undefined ? synonymsIndexResourceModel : {}) : (synonymsIndexResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {SynonymsIndexItemResourceModel} synonymsIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsIndexItem: async (groupId, indexId, indexItemId, synonymsIndexItemResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateSynonymsIndexItem.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling updateSynonymsIndexItem.');
            }
            // verify required parameter 'indexItemId' is not null or undefined
            if (indexItemId === null || indexItemId === undefined) {
                throw new base_1.RequiredError('indexItemId', 'Required parameter indexItemId was null or undefined when calling updateSynonymsIndexItem.');
            }
            // verify required parameter 'synonymsIndexItemResourceModel' is not null or undefined
            if (synonymsIndexItemResourceModel === null || synonymsIndexItemResourceModel === undefined) {
                throw new base_1.RequiredError('synonymsIndexItemResourceModel', 'Required parameter synonymsIndexItemResourceModel was null or undefined when calling updateSynonymsIndexItem.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes/{indexId}/items/{indexItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)))
                .replace(`{${"indexItemId"}}`, encodeURIComponent(String(indexItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof synonymsIndexItemResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(synonymsIndexItemResourceModel !== undefined ? synonymsIndexItemResourceModel : {}) : (synonymsIndexItemResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsIndexLastSyncEnd: async (groupId, indexId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateSynonymsIndexLastSyncEnd.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling updateSynonymsIndexLastSyncEnd.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes/{indexId}/lastsyncend`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsIndexLastSyncStart: async (groupId, indexId, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateSynonymsIndexLastSyncStart.');
            }
            // verify required parameter 'indexId' is not null or undefined
            if (indexId === null || indexId === undefined) {
                throw new base_1.RequiredError('indexId', 'Required parameter indexId was null or undefined when calling updateSynonymsIndexLastSyncStart.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/indexes/{indexId}/lastsyncstart`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"indexId"}}`, encodeURIComponent(String(indexId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {SynonymsListResourceModel} synonymsListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsList: async (groupId, listId, synonymsListResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateSynonymsList.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling updateSynonymsList.');
            }
            // verify required parameter 'synonymsListResourceModel' is not null or undefined
            if (synonymsListResourceModel === null || synonymsListResourceModel === undefined) {
                throw new base_1.RequiredError('synonymsListResourceModel', 'Required parameter synonymsListResourceModel was null or undefined when calling updateSynonymsList.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/lists/{listId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof synonymsListResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(synonymsListResourceModel !== undefined ? synonymsListResourceModel : {}) : (synonymsListResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {SynonymsListItemResourceModel} synonymsListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsListItem: async (groupId, listId, listItemId, synonymsListItemResourceModel, options = {}) => {
            // verify required parameter 'groupId' is not null or undefined
            if (groupId === null || groupId === undefined) {
                throw new base_1.RequiredError('groupId', 'Required parameter groupId was null or undefined when calling updateSynonymsListItem.');
            }
            // verify required parameter 'listId' is not null or undefined
            if (listId === null || listId === undefined) {
                throw new base_1.RequiredError('listId', 'Required parameter listId was null or undefined when calling updateSynonymsListItem.');
            }
            // verify required parameter 'listItemId' is not null or undefined
            if (listItemId === null || listItemId === undefined) {
                throw new base_1.RequiredError('listItemId', 'Required parameter listItemId was null or undefined when calling updateSynonymsListItem.');
            }
            // verify required parameter 'synonymsListItemResourceModel' is not null or undefined
            if (synonymsListItemResourceModel === null || synonymsListItemResourceModel === undefined) {
                throw new base_1.RequiredError('synonymsListItemResourceModel', 'Required parameter synonymsListItemResourceModel was null or undefined when calling updateSynonymsListItem.');
            }
            const localVarPath = `/api/groups/{groupId}/synonyms/lists/{listId}/items/{listItemId}`
                .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"listId"}}`, encodeURIComponent(String(listId)))
                .replace(`{${"listItemId"}}`, encodeURIComponent(String(listItemId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication keycloak required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query };
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            const needsSerialization = (typeof synonymsListItemResourceModel !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(synonymsListItemResourceModel !== undefined ? synonymsListItemResourceModel : {}) : (synonymsListItemResourceModel || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SynonymsApi - functional programming interface
 * @export
 */
exports.SynonymsApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {SynonymsIndexResourceModel} synonymsIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSynonymsIndex(groupId, synonymsIndexResourceModel, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).createSynonymsIndex(groupId, synonymsIndexResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {SynonymsIndexItemResourceModel} synonymsIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSynonymsIndexItem(groupId, indexId, synonymsIndexItemResourceModel, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).createSynonymsIndexItem(groupId, indexId, synonymsIndexItemResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {SynonymsListResourceModel} synonymsListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSynonymsList(groupId, synonymsListResourceModel, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).createSynonymsList(groupId, synonymsListResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {SynonymsListItemResourceModel} synonymsListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSynonymsListItem(groupId, listId, synonymsListItemResourceModel, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).createSynonymsListItem(groupId, listId, synonymsListItemResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSynonymsIndex(groupId, indexId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).deleteSynonymsIndex(groupId, indexId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSynonymsIndexItem(groupId, indexId, indexItemId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).deleteSynonymsIndexItem(groupId, indexId, indexItemId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSynonymsList(groupId, listId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).deleteSynonymsList(groupId, listId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSynonymsListItem(groupId, listId, listItemId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).deleteSynonymsListItem(groupId, listId, listItemId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSynonymsIndex(groupId, indexId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).getSynonymsIndex(groupId, indexId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSynonymsIndexItem(groupId, indexId, indexItemId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).getSynonymsIndexItem(groupId, indexId, indexItemId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSynonymsIndexItems(groupId, indexId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).getSynonymsIndexItems(groupId, indexId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSynonymsIndexes(groupId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).getSynonymsIndexes(groupId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSynonymsList(groupId, listId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).getSynonymsList(groupId, listId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSynonymsListItem(groupId, listId, listItemId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).getSynonymsListItem(groupId, listId, listItemId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSynonymsListItems(groupId, listId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).getSynonymsListItems(groupId, listId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {Array<string>} [indexIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSynonymsLists(groupId, indexIds, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).getSynonymsLists(groupId, indexIds, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {SynonymsIndexResourceModel} synonymsIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSynonymsIndex(groupId, indexId, synonymsIndexResourceModel, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).updateSynonymsIndex(groupId, indexId, synonymsIndexResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {SynonymsIndexItemResourceModel} synonymsIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSynonymsIndexItem(groupId, indexId, indexItemId, synonymsIndexItemResourceModel, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).updateSynonymsIndexItem(groupId, indexId, indexItemId, synonymsIndexItemResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSynonymsIndexLastSyncEnd(groupId, indexId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).updateSynonymsIndexLastSyncEnd(groupId, indexId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSynonymsIndexLastSyncStart(groupId, indexId, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).updateSynonymsIndexLastSyncStart(groupId, indexId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {SynonymsListResourceModel} synonymsListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSynonymsList(groupId, listId, synonymsListResourceModel, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).updateSynonymsList(groupId, listId, synonymsListResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {SynonymsListItemResourceModel} synonymsListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSynonymsListItem(groupId, listId, listItemId, synonymsListItemResourceModel, options) {
            const localVarAxiosArgs = await exports.SynonymsApiAxiosParamCreator(configuration).updateSynonymsListItem(groupId, listId, listItemId, synonymsListItemResourceModel, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * SynonymsApi - factory interface
 * @export
 */
exports.SynonymsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @param {string} groupId
         * @param {SynonymsIndexResourceModel} synonymsIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSynonymsIndex(groupId, synonymsIndexResourceModel, options) {
            return exports.SynonymsApiFp(configuration).createSynonymsIndex(groupId, synonymsIndexResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {SynonymsIndexItemResourceModel} synonymsIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSynonymsIndexItem(groupId, indexId, synonymsIndexItemResourceModel, options) {
            return exports.SynonymsApiFp(configuration).createSynonymsIndexItem(groupId, indexId, synonymsIndexItemResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {SynonymsListResourceModel} synonymsListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSynonymsList(groupId, synonymsListResourceModel, options) {
            return exports.SynonymsApiFp(configuration).createSynonymsList(groupId, synonymsListResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {SynonymsListItemResourceModel} synonymsListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSynonymsListItem(groupId, listId, synonymsListItemResourceModel, options) {
            return exports.SynonymsApiFp(configuration).createSynonymsListItem(groupId, listId, synonymsListItemResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSynonymsIndex(groupId, indexId, options) {
            return exports.SynonymsApiFp(configuration).deleteSynonymsIndex(groupId, indexId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSynonymsIndexItem(groupId, indexId, indexItemId, options) {
            return exports.SynonymsApiFp(configuration).deleteSynonymsIndexItem(groupId, indexId, indexItemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSynonymsList(groupId, listId, options) {
            return exports.SynonymsApiFp(configuration).deleteSynonymsList(groupId, listId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSynonymsListItem(groupId, listId, listItemId, options) {
            return exports.SynonymsApiFp(configuration).deleteSynonymsListItem(groupId, listId, listItemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsIndex(groupId, indexId, options) {
            return exports.SynonymsApiFp(configuration).getSynonymsIndex(groupId, indexId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsIndexItem(groupId, indexId, indexItemId, options) {
            return exports.SynonymsApiFp(configuration).getSynonymsIndexItem(groupId, indexId, indexItemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsIndexItems(groupId, indexId, options) {
            return exports.SynonymsApiFp(configuration).getSynonymsIndexItems(groupId, indexId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsIndexes(groupId, options) {
            return exports.SynonymsApiFp(configuration).getSynonymsIndexes(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsList(groupId, listId, options) {
            return exports.SynonymsApiFp(configuration).getSynonymsList(groupId, listId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsListItem(groupId, listId, listItemId, options) {
            return exports.SynonymsApiFp(configuration).getSynonymsListItem(groupId, listId, listItemId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsListItems(groupId, listId, options) {
            return exports.SynonymsApiFp(configuration).getSynonymsListItems(groupId, listId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {Array<string>} [indexIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSynonymsLists(groupId, indexIds, options) {
            return exports.SynonymsApiFp(configuration).getSynonymsLists(groupId, indexIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {SynonymsIndexResourceModel} synonymsIndexResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsIndex(groupId, indexId, synonymsIndexResourceModel, options) {
            return exports.SynonymsApiFp(configuration).updateSynonymsIndex(groupId, indexId, synonymsIndexResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {string} indexItemId
         * @param {SynonymsIndexItemResourceModel} synonymsIndexItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsIndexItem(groupId, indexId, indexItemId, synonymsIndexItemResourceModel, options) {
            return exports.SynonymsApiFp(configuration).updateSynonymsIndexItem(groupId, indexId, indexItemId, synonymsIndexItemResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsIndexLastSyncEnd(groupId, indexId, options) {
            return exports.SynonymsApiFp(configuration).updateSynonymsIndexLastSyncEnd(groupId, indexId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} indexId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsIndexLastSyncStart(groupId, indexId, options) {
            return exports.SynonymsApiFp(configuration).updateSynonymsIndexLastSyncStart(groupId, indexId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {SynonymsListResourceModel} synonymsListResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsList(groupId, listId, synonymsListResourceModel, options) {
            return exports.SynonymsApiFp(configuration).updateSynonymsList(groupId, listId, synonymsListResourceModel, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} groupId
         * @param {string} listId
         * @param {string} listItemId
         * @param {SynonymsListItemResourceModel} synonymsListItemResourceModel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSynonymsListItem(groupId, listId, listItemId, synonymsListItemResourceModel, options) {
            return exports.SynonymsApiFp(configuration).updateSynonymsListItem(groupId, listId, listItemId, synonymsListItemResourceModel, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SynonymsApi - object-oriented interface
 * @export
 * @class SynonymsApi
 * @extends {BaseAPI}
 */
class SynonymsApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} groupId
     * @param {SynonymsIndexResourceModel} synonymsIndexResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    createSynonymsIndex(groupId, synonymsIndexResourceModel, options) {
        return exports.SynonymsApiFp(this.configuration).createSynonymsIndex(groupId, synonymsIndexResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {SynonymsIndexItemResourceModel} synonymsIndexItemResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    createSynonymsIndexItem(groupId, indexId, synonymsIndexItemResourceModel, options) {
        return exports.SynonymsApiFp(this.configuration).createSynonymsIndexItem(groupId, indexId, synonymsIndexItemResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {SynonymsListResourceModel} synonymsListResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    createSynonymsList(groupId, synonymsListResourceModel, options) {
        return exports.SynonymsApiFp(this.configuration).createSynonymsList(groupId, synonymsListResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {SynonymsListItemResourceModel} synonymsListItemResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    createSynonymsListItem(groupId, listId, synonymsListItemResourceModel, options) {
        return exports.SynonymsApiFp(this.configuration).createSynonymsListItem(groupId, listId, synonymsListItemResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    deleteSynonymsIndex(groupId, indexId, options) {
        return exports.SynonymsApiFp(this.configuration).deleteSynonymsIndex(groupId, indexId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {string} indexItemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    deleteSynonymsIndexItem(groupId, indexId, indexItemId, options) {
        return exports.SynonymsApiFp(this.configuration).deleteSynonymsIndexItem(groupId, indexId, indexItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    deleteSynonymsList(groupId, listId, options) {
        return exports.SynonymsApiFp(this.configuration).deleteSynonymsList(groupId, listId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {string} listItemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    deleteSynonymsListItem(groupId, listId, listItemId, options) {
        return exports.SynonymsApiFp(this.configuration).deleteSynonymsListItem(groupId, listId, listItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    getSynonymsIndex(groupId, indexId, options) {
        return exports.SynonymsApiFp(this.configuration).getSynonymsIndex(groupId, indexId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {string} indexItemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    getSynonymsIndexItem(groupId, indexId, indexItemId, options) {
        return exports.SynonymsApiFp(this.configuration).getSynonymsIndexItem(groupId, indexId, indexItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    getSynonymsIndexItems(groupId, indexId, options) {
        return exports.SynonymsApiFp(this.configuration).getSynonymsIndexItems(groupId, indexId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    getSynonymsIndexes(groupId, options) {
        return exports.SynonymsApiFp(this.configuration).getSynonymsIndexes(groupId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    getSynonymsList(groupId, listId, options) {
        return exports.SynonymsApiFp(this.configuration).getSynonymsList(groupId, listId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {string} listItemId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    getSynonymsListItem(groupId, listId, listItemId, options) {
        return exports.SynonymsApiFp(this.configuration).getSynonymsListItem(groupId, listId, listItemId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    getSynonymsListItems(groupId, listId, options) {
        return exports.SynonymsApiFp(this.configuration).getSynonymsListItems(groupId, listId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {Array<string>} [indexIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    getSynonymsLists(groupId, indexIds, options) {
        return exports.SynonymsApiFp(this.configuration).getSynonymsLists(groupId, indexIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {SynonymsIndexResourceModel} synonymsIndexResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    updateSynonymsIndex(groupId, indexId, synonymsIndexResourceModel, options) {
        return exports.SynonymsApiFp(this.configuration).updateSynonymsIndex(groupId, indexId, synonymsIndexResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {string} indexItemId
     * @param {SynonymsIndexItemResourceModel} synonymsIndexItemResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    updateSynonymsIndexItem(groupId, indexId, indexItemId, synonymsIndexItemResourceModel, options) {
        return exports.SynonymsApiFp(this.configuration).updateSynonymsIndexItem(groupId, indexId, indexItemId, synonymsIndexItemResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    updateSynonymsIndexLastSyncEnd(groupId, indexId, options) {
        return exports.SynonymsApiFp(this.configuration).updateSynonymsIndexLastSyncEnd(groupId, indexId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} indexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    updateSynonymsIndexLastSyncStart(groupId, indexId, options) {
        return exports.SynonymsApiFp(this.configuration).updateSynonymsIndexLastSyncStart(groupId, indexId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {SynonymsListResourceModel} synonymsListResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    updateSynonymsList(groupId, listId, synonymsListResourceModel, options) {
        return exports.SynonymsApiFp(this.configuration).updateSynonymsList(groupId, listId, synonymsListResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} groupId
     * @param {string} listId
     * @param {string} listItemId
     * @param {SynonymsListItemResourceModel} synonymsListItemResourceModel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SynonymsApi
     */
    updateSynonymsListItem(groupId, listId, listItemId, synonymsListItemResourceModel, options) {
        return exports.SynonymsApiFp(this.configuration).updateSynonymsListItem(groupId, listId, listItemId, synonymsListItemResourceModel, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SynonymsApi = SynonymsApi;
